module.exports = __webpack_public_path__ + "static/media/octagon.60fab14b.jpg";